import React, { createElement } from 'react';
import { Col } from 'antd';
import FormRow from '../../../common/formComponents/FormRow/FormRow';

const FieldsRow = ({
  gutter = 0,
  fields,
  rowType = 'field',
  index,
  form,
  onRemoveField,
  ...props
}) => {
  return (
    <FormRow {...props} gutter={gutter} rowType={rowType}>
      {fields.map((field) => {
        const { span, withRemoveIcon, name, element, ...otherData } = field;

        const fieldName = typeof index === 'number' ? `${name}-${index}` : name;

        const props = { ...otherData, name: fieldName, form };

        if (withRemoveIcon && onRemoveField) {
          props.onRemoveField = onRemoveField;
        }

        return (
          <Col key={fieldName} span={span}>
            {createElement(element, props)}
          </Col>
        );
      })}
    </FormRow>
  );
};

export default FieldsRow;
